import React from 'react';
import { Descriptions, Spin } from 'antd';
import getFormattedValue from 'store/redux/utils/getFormattedValue';
import Icon from '@mdi/react';
import { mdiInfinity } from '@mdi/js';

const UrlCostPreview = ({ previewData, isLoading, inifinite = true }) => {
  const items = [
    {
      key: 'daily_cost',
      label: 'Daily Cost',
      children: getFormattedValue(previewData?.daily_cost, previewData?.currency),
    },
    {
      key: 'total_cost',
      label: 'Total Cost',
      children:
        inifinite === 'infinite' ? (
          <Icon path={mdiInfinity} size={0.6} />
        ) : (
          getFormattedValue(previewData?.total_cost, previewData?.currency)
        ),
    },
  ];

  if (isLoading) {
    return (
      <div className='flex justify-center items-center h-full my-4'>
        <Spin />
      </div>
    );
  }

  if (!previewData) return null;

  return <Descriptions layout='vertical' bordered items={items} size='small' className='mt-5' />;
};

export default UrlCostPreview;
